import { Button, Modal } from '@skupreme/shared/ui';
import type { ReactNode } from 'react';

export type ConfirmListingModalProps = {
  isOpen: boolean;
  title: string;
  children: ReactNode;
  confirmLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
};

/** Asks before a listing is discarded or unlinked: neither can be undone here. */
export function ConfirmListingModal({
  isOpen,
  title,
  children,
  confirmLabel,
  onClose,
  onConfirm,
  isProcessing,
}: ConfirmListingModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={open => !open && onClose()}
      title={title}
      isDismissable={!isProcessing}
      footer={
        <div className="sk:flex sk:justify-end sk:gap-2">
          <Button
            variant="pill"
            size="md"
            isDisabled={isProcessing}
            onPress={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            size="md"
            isDisabled={isProcessing}
            onPress={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      }
    >
      <p className="sk:m-0 sk:text-sm sk:text-fg-secondary">{children}</p>
    </Modal>
  );
}
